<template>
  <div class="mt-4 px-4 container-fluid">
    <div class="breadcrumb text-md px-0 mb-4">
      <p><span class="breadcrumb-item" @click="irInicio">Inicio</span> > Canales</p>
    </div>
  </div>
  
  <div class="px-4 container-fluid">
    <div class="row">
      <div class="col-12">
        <div class="card ficha-buscador">
          <div class="titulo"><h5 class="mx-4 mt-5 mb-5">Listado de canales de Telegram</h5></div>
          <div class="table-search">
            <input id="textoBuscador" type="text" class="form-control" placeholder="Búsqueda rápida..." aria-label="Búsqueda rápida" @input="teclearBuscador" />
          </div>
          <div class="filtro-tipster" v-if="miRol == 1">
            <select v-model="filtroTipsterId" class="form-control form-control-sm" @change="cambiarFiltroTipster">
              <option value="">Todos los tipsters</option>
              <option v-for="t in listaTipsters" :key="t.id" :value="t.id">{{ t.nombre }}</option>
            </select>
          </div>
          <div class="descarga triple">
            <p @click="descargarCSV"><i class="fa fa-download" aria-hidden="true"></i></p>
            <p @click="abrirAltaCanal"><i class="fa fa-plus" aria-hidden="true"></i></p>
            <p @click="toggleSelectorColumnas" title="Columnas visibles" :class="{ 'activo': selectorColumnasAbierto }"><i class="fas fa-columns" aria-hidden="true"></i></p>
          </div>

          <!-- Selector de columnas -->
          <div v-if="selectorColumnasAbierto" class="selector-columnas-panel" v-click-outside="cerrarSelectorColumnas">
            <div class="selector-columnas-header">
              <span>Columnas visibles</span>
              <button class="selector-reset" @click="resetColumnas" title="Restablecer">Restablecer</button>
            </div>
            <div class="selector-columnas-grid">
              <label v-for="col in columnasConfig" :key="col.key" class="selector-col-item" :class="{ disabled: col.fija }">
                <input type="checkbox" v-model="columnasVisibles[col.key]" :disabled="col.fija" @change="guardarColumnasStorage" />
                <span class="selector-col-dot" :style="{ background: col.color }"></span>
                <span>{{ col.label }}</span>
              </label>
            </div>
          </div>
          <!-- Filtros tipo canal -->
          <div class="filtros-canal">
            <div class="filtros-canal__grupo">
              <button
                v-for="op in [{ val:'', label:'Todos' }, { val:'P', label:'Activos' }, { val:'I', label:'Inicializando' }]"
                :key="op.val"
                class="filtro-pill"
                :class="{ 'filtro-pill--active': filtroEstadoCanal === op.val }"
                @click="filtroEstadoCanal = op.val"
              >{{ op.label }}</button>
            </div>
            <div class="filtros-canal__grupo">
              <button
                v-for="op in [{ val:'', label:'Todos' }, { val:'free', label:'Free' }, { val:'premium', label:'Premium' }]"
                :key="op.val"
                class="filtro-pill"
                :class="{ 'filtro-pill--active': filtroTipo === op.val }"
                @click="filtroTipo = op.val"
              >{{ op.label }}</button>
            </div>
          </div>
          <div class="borrados">
            <QToggle v-model="mostrarBorrados" @change="cambiarBorrados" />
            <span class="borrados-label">{{ mostrarBorrados ? 'Con eliminados' : 'Sin eliminados' }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="px-4 container-fluid">
    <div class="row">
      <div class="col-12">
        <div class="card ficha-listado mt-4">
          <div class="px-4 pb-0 card-body">
            <div class="table-responsive mb-4">
              <table id="canales-list" class="table table-flush table-listado">
                <thead class="thead-light">
                  <tr>
                    <th @click="sortTable('0')" :class="sortColumn=='0' ? sortDirection : ''">Nombre</th>
                    <th @click="sortTable('1')" :class="[sortColumn=='1' ? sortDirection : '', { 'd-none': !columnasVisibles.suscripciones }]">Suscripc.</th>
                    <th @click="sortTable('2')" :class="[sortColumn=='2' ? sortDirection : '', { 'd-none': !columnasVisibles.entradas }]">Entradas</th>
                    <th @click="sortTable('3')" :class="[sortColumn=='3' ? sortDirection : '', { 'd-none': !columnasVisibles.salidas }]">Salidas</th>
                    <th @click="sortTable('4')" :class="[sortColumn=='4' ? sortDirection : '', { 'd-none': !columnasVisibles.num_pagos }]">Núm.pagos</th>
                    <th @click="sortTable('5')" :class="[sortColumn=='5' ? sortDirection : '', { 'd-none': !columnasVisibles.imp_pagos }]">Imp.pagos</th>
                    <th @click="sortTable('6')" v-if="miRol==1" :class="[sortColumn=='6' ? sortDirection : '', { 'd-none': !columnasVisibles.tipster }]">Tipster</th>
                    <th @click="sortTable('7')" :class="sortColumn=='7' ? sortDirection : ''">Estado</th>
                    <th @click="sortTable('8')" :class="[sortColumn=='8' ? sortDirection : '', { 'd-none': !columnasVisibles.creado }]" data-type="date" data-format="DD/MM/YYYY">Creado</th>
                    <th @click="sortTable('9')" v-if="mostrarBorrados" :class="[sortColumn=='9' ? sortDirection : '', { 'd-none': !columnasVisibles.eliminado }]">Eliminado</th>
                    <th data-type="html" data-sortable="false" class="sin-orden">Acciones</th>
                  </tr>
                </thead>
                <tbody class="text-sm">
                  <!-- Ciclo a través de los elementos filtrados y paginados -->
                  <tr v-for="row in filasVisibles" :key="row.id">
                    <td>
                      {{ row.nombre }}
                      <span v-if="row.esPremium" class="canal-badge canal-badge--premium">Premium</span>
                      <span v-else class="canal-badge canal-badge--free">Free</span>
                    </td>
                    <td :class="{ 'd-none': !columnasVisibles.suscripciones }">{{ row.suscripciones }}</td>
                    <td :class="{ 'd-none': !columnasVisibles.entradas }">{{ row.entradas }}</td>
                    <td :class="{ 'd-none': !columnasVisibles.salidas }">{{ row.salidas }}</td>
                    <td :class="{ 'd-none': !columnasVisibles.num_pagos }">{{ row.numero_pagos }}</td>
                    <td :class="{ 'd-none': !columnasVisibles.imp_pagos }">{{ row.importe_pagos }}</td>
                    <td v-if="miRol==1" :class="{ 'd-none': !columnasVisibles.tipster }">{{ row.tipster_name }}</td>
                    <td>{{ row.estadoTxt }}</td>
                    <td :class="{ 'd-none': !columnasVisibles.creado }">{{ row.created }}</td>
                    <td v-if="mostrarBorrados" :class="{ 'd-none': !columnasVisibles.eliminado }">{{ row.deleted }}</td>
                    <td>
                      <template v-if="!row.deleted">
                        <a href="#" class="cursor-pointer me-3" title="Editar canal" @click.prevent="editarCanal(row.id)">
                          <i class="fas fa-edit text-secondary"></i>
                        </a>
                        <a href="#" class="cursor-pointer me-3" title="Eliminar canal" @click.prevent="mostrarConfirmacionBorrar(row.id)">
                          <i class="fas fa-trash text-secondary"></i>
                        </a>
                        <a v-if="row.estado=='P'" href="#" class="cursor-pointer me-3" title="Movimientos del canal Telegram" @click.prevent="$router.push({ name: 'GrupoTelegram', params: { idCanal: row.id } })">
                          <i class="fas fa-list text-secondary"></i>
                        </a>
                        <a v-if="row.estado=='I'" href="#" class="cursor-pointer me-3" title="Copiar comando de inicialización" @click.prevent="copiarInitCanal(row.uuid)">
                          <i class="fas fa-clipboard text-secondary"></i>
                        </a>
                        <a href="#" class="cursor-pointer me-3" title="Ver productos asociados" @click.prevent="verProductosCanal(row.id, row.nombre)">
                          <i class="fas fa-eye text-secondary"></i>
                        </a>
                      </template>
                    </td>
                  </tr>
                  <tr v-if="filasVisibles.length==0"><td colspan="10">No hay registros que mostrar</td></tr>
                </tbody>
              </table>
            </div>
            <!-- Control de la Paginacion manual -->
            <div class="paginacion" v-if="filasVisibles.length>0">
              <p class="contador-listado">Mostrando {{ mostradosIni }} a {{ mostradosFin }} de {{ mostradosTotal }} registros</p>

              <ul class="pagination pagination-md" v-if="paginaTotal>1">
                <li class="page-item prev-page" v-if="paginaActual>1">
                  <a class="page-link" aria-label="Previous" @click="paginaActual=paginaActual-1;fetchAndSetCanales();">
                    <i class="fa fa-angle-left" aria-hidden="true"></i>
                  </a>
                </li>
                <li v-for="index in rangoPaginas" :key="index" class="page-item" :class="index==paginaActual ? 'active disabled' : ''">
                  <a class="page-link" @click="paginaActual=index;fetchAndSetCanales();">{{index}}</a>
                </li>
                <li class="page-item next-page" v-if="paginaActual<paginaTotal">
                  <a class="page-link" aria-label="Next" @click="paginaActual=paginaActual+1;fetchAndSetCanales();">
                    <i class="fa fa-angle-right" aria-hidden="true"></i>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <Modal @cerrar-modal="cerrarModal" :modalActive="modalActive">
    <div class="modal-content">
      <alta-canal-form v-if="tipoModal=='A'" @cerrar-modal="() => { modalActive=false;fetchAndSetCanales();}" :key="0" :canalBotName="botName"/>
      <edita-canal-form v-if="tipoModal=='E'" @cerrar-modal="(resp) => { modalActive=false;fetchAndSetCanales();}" :key="canalEditId" :canalId="canalEditId" :canalEstado="canalEditEstado" :canalNombre="canalEditNombre" :canalUuid="canalEditUuid"/>
    </div>
  </Modal>

  <!-- Panel productos del canal -->
  <div v-if="panelProductosVisible" class="overlay" @click.self="panelProductosVisible=false">
    <div class="confirm-box panel-productos">
      <div class="panel-productos__header">
        <h6>Productos de <strong>{{ panelCanalNombre }}</strong></h6>
        <button class="panel-productos__close" @click="panelProductosVisible=false"><i class="fas fa-times"></i></button>
      </div>
      <div v-if="panelProductosCargando" class="panel-productos__loading">Cargando...</div>
      <div v-else-if="panelProductos.length === 0" class="panel-productos__empty">Sin productos asociados</div>
      <table v-else class="panel-productos__tabla">
        <thead>
          <tr><th>Nombre</th><th>Precio</th><th>Tipo</th><th>Estado</th></tr>
        </thead>
        <tbody>
          <tr v-for="p in panelProductos" :key="p.id" :class="p.borrado ? 'row-borrado' : ''">
            <td>{{ p.nombre }}</td>
            <td>{{ p.precio }} {{ p.moneda }}</td>
            <td>{{ p.tipo_venta === 'suscripcion' ? 'Suscripción' : 'Pago único' }}</td>
            <td>
              <span v-if="p.borrado" class="badge-estado badge-borrado">Eliminado</span>
              <span v-else-if="p.activo" class="badge-estado badge-activo">Activo</span>
              <span v-else class="badge-estado badge-inactivo">Inactivo</span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

  <div v-if="confirmacionVisible" class="overlay">
    <div class="confirm-box">
      <p class="mt-4 mb-4">{{ mensajeConfirmacion }}</p>
      <table class="mt-4 mb-4"><tr>
        <td width="50%"><QBtn variant="cancela" label="Cancelar" :disabled="loadingBorrar" @click="cancelacion" /></td>
        <td width="50%"><QBtn variant="confirma" label="Confirmar" :loading="loadingBorrar" :disabled="loadingBorrar" @click="confirmacion" /></td>
      </tr></table>
    </div>
  </div>
</template>

<script>
import showSwal from "@/mixins/showSwal.js";
import Modal from './components/Modal.vue';
import AltaCanalForm from './components/AltaCanalForm.vue';
import EditaCanalForm from './components/EditaCanalForm.vue';
import {globalFunctionsMixin} from '@/mixins/globalFunctions.js';

const STORAGE_KEY_COLUMNAS = 'canales_columnas_v1';

const COLUMNAS_DEFAULT = {
  suscripciones: true, entradas: true, salidas: true, num_pagos: true, imp_pagos: true, tipster: true, creado: true, eliminado: true,
};

const COLUMNAS_MOBILE = {
  suscripciones: true, entradas: false, salidas: false, num_pagos: false, imp_pagos: false, tipster: false, creado: false, eliminado: false,
};

export default {
  name: "Canales",
  components: {
    Modal,
    AltaCanalForm,
    EditaCanalForm,
  },
  directives: {
    clickOutside: {
      beforeMount(el, binding) {
        el._clickOutsideHandler = (e) => { if (!el.contains(e.target)) binding.value(e); };
        setTimeout(() => document.addEventListener('click', el._clickOutsideHandler), 0);
      },
      unmounted(el) { document.removeEventListener('click', el._clickOutsideHandler); },
    },
  },
  mixins: [globalFunctionsMixin],
  data() {
    return {
      filas: [],
      filasBoton: [],
      confirmacionVisible: false,
      canalId: 0,
      mensajeConfirmacion: '',
      tipoModal: '',
      canalEditId: 0,
      canalEditNombre: '',
      canalEditEstado: '',
      canalEditUuid: '',
      validaTipsterId: '',
      validaTelefono: '',
      listaTipsters: [],
      filtroTipsterId: '',
      textoBuscador: '',
      paginaActual: 0,
      paginaTotal: 0,
      mostrarBorrados: false,
      mostradosIni: 0,
      mostradosFin: 0,
      mostradosTotal: 0,
      sortColumn: 0,
      sortDirection: '',
      modalActive: false,
      searchTimeout: null,
      botName: '',
      loadingBorrar: false,
      filtroTipo: '',
      filtroEstadoCanal: '',
      panelProductosVisible: false,
      panelCanalNombre: '',
      panelProductos: [],
      panelProductosCargando: false,
      selectorColumnasAbierto: false,
      columnasVisibles: { ...COLUMNAS_DEFAULT },
    };
  },
  computed: {
    miRol() { return this.$store.getters["auth/rolEfectivo"]; },
    columnasConfig() {
      const cols = [
        { key: 'suscripciones', label: 'Suscripc.',  color: '#10b981' },
        { key: 'entradas',      label: 'Entradas',    color: '#3b82f6' },
        { key: 'salidas',       label: 'Salidas',     color: '#6b7280' },
        { key: 'num_pagos',     label: 'Núm.pagos',   color: '#00e676' },
        { key: 'imp_pagos',     label: 'Imp.pagos',   color: '#00e676' },
        { key: 'creado',        label: 'Creado',      color: '#6b7280' },
      ];
      if (Number(this.miRol) === 1) {
        cols.splice(5, 0, { key: 'tipster', label: 'Tipster', color: '#6b7280' });
      }
      if (this.mostrarBorrados) {
        cols.push({ key: 'eliminado', label: 'Eliminado', color: '#ef4444' });
      }
      return cols;
    },
    filasVisibles() {
      let rows = this.filas;
      if (this.filtroTipo === 'free') rows = rows.filter(r => !r.esPremium);
      else if (this.filtroTipo === 'premium') rows = rows.filter(r => r.esPremium);
      if (this.filtroEstadoCanal) rows = rows.filter(r => r.estado === this.filtroEstadoCanal);
      return rows;
    },
    rangoPaginas() {
      let startPage = Math.max(this.paginaActual - 3, 1);
      let endPage = Math.min(this.paginaActual + 3,this.paginaTotal);
      let pages = [];
      for (let i = startPage; i <= endPage; i++) {
        pages.push(i);
      }
      return pages;
    }
  },
  methods: {
    toggleSelectorColumnas() {
      this.selectorColumnasAbierto = !this.selectorColumnasAbierto;
    },
    cerrarSelectorColumnas() {
      this.selectorColumnasAbierto = false;
    },
    guardarColumnasStorage() {
      try { localStorage.setItem(STORAGE_KEY_COLUMNAS, JSON.stringify(this.columnasVisibles)); } catch (e) { /* storage no disponible */ }
    },
    resetColumnas() {
      const esMobile = window.innerWidth < 768;
      this.columnasVisibles = { ...(esMobile ? COLUMNAS_MOBILE : COLUMNAS_DEFAULT) };
      this.guardarColumnasStorage();
    },
    cargarColumnasStorage() {
      try {
        const guardado = localStorage.getItem(STORAGE_KEY_COLUMNAS);
        if (guardado) {
          this.columnasVisibles = { ...COLUMNAS_DEFAULT, ...JSON.parse(guardado) };
        } else {
          this.columnasVisibles = { ...(window.innerWidth < 768 ? COLUMNAS_MOBILE : COLUMNAS_DEFAULT) };
        }
      } catch {
        this.columnasVisibles = { ...COLUMNAS_DEFAULT };
      }
    },
    alert() {
      showSwal.methods.showSwal({
        type: "error",
        message: "This is a PRO feature.",
        width: 400,
      });
    },

    async descargarCSV() {
      try {
        const response = await this.$store.dispatch("auth/exportarCanales");
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "canales_" + new Date().toISOString().slice(0, 10) + ".xlsx");
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
      } catch (e) {
        showSwal.methods.showSwal({ type: "error", message: "No se pudo generar el archivo.", width: 400 });
      }
    },

    async initializeDataTable() {

      this.sortColumn=8;
      this.sortDirection='desc';
      this.textoBuscador = '';
      this.paginaActual = 1;
      await this.fetchAndSetCanales();

    },

    sortTable(key) {
      // Alternar entre ascendente y descendente al hacer clic en el encabezado
      if (this.sortColumn === key) {
        this.sortDirection = this.sortDirection=='asc' ? 'desc' : 'asc';
      } else {
        this.sortColumn = key;
        this.sortDirection = 'asc';
      }
      this.fetchAndSetCanales();
    },

    cambiarFiltroTipster() {
      this.paginaActual = 1;
      this.fetchAndSetCanales();
    },

    teclearBuscador(event) {
      this.textoBuscador = event.target.value;
      clearTimeout(this.searchTimeout);
      this.searchTimeout = setTimeout(() => {
        this.fetchAndSetCanales();
      }, 500);
    },

    async fetchAndSetCanales() {
      try {
        // Petición al servidor
        const response = await this.$store.dispatch("auth/canales", { textoBuscador: this.textoBuscador, paginaActual: this.paginaActual, mostrarBorrados: this.mostrarBorrados, sortColumn: this.sortColumn, sortDirection: this.sortDirection, tipster_id: this.filtroTipsterId || null });

        // Procesar los datos y actualizarlos en el DataTable
        this.filas = response.data.map(row => ({
          id: row.id,
          nombre: row.nombre,
          suscripciones: row.suscripciones,
          entradas: row.entradas,
          salidas: row.salidas,
          numero_pagos: row.numero_pagos,
          importe_pagos: row.importe_pagos,
          tipster_name: row.tipster_name,
          estado: row.estado,
          uuid: row.uuid,
          estadoTxt: row.estadoTxt,
          esPremium: row.tiene_producto === true,
          created: this.formatDate(row.created_at, 'DD/MM/YYYY'),
          deleted: row.deleted_at ? this.formatDate(row.deleted_at, 'DD/MM/YYYY') : '',
        }));
        this.filasBoton = response.data.map(row => ({
          id: row.id,
          nombre: row.nombre,
          uuid: row.uuid,
          estado: row.estado,
        }));

        this.paginaTotal = response.paginas;
        this.mostradosIni = (response.actual-1)*response.porpagina + 1;
        this.mostradosFin = Math.min(response.totales,response.actual*response.porpagina);
        this.mostradosTotal = response.totales;
        this.botName = response.botname;

      } catch (error) {
        console.error('Error fetching data:', error);
      }
    },

    mostrarConfirmacionBorrar(id) { 
      this.confirmacionVisible = true;
      this.canalId = id;
      this.mensajeConfirmacion = '¿Confirma que desea eliminar este canal?';
    },
    confirmacion() {
      this.loadingBorrar = true;
      this.borrarCanal(this.canalId);
    },
    cancelacion() {
      this.confirmacionVisible = false;
    },
    async abrirAltaCanal() {
      this.tipoModal = 'A';
      this.modalActive = true; 
    },
    cerrarModal() {
      this.modalActive = false;
    },
    async cambiarBorrados() {
      await this.initializeDataTable();
    },
    async borrarCanal(canalId) {
      try {
        const resp = await this.$store.dispatch("auth/borraCanal",{id: canalId});
        if (resp.res=='OK') {
            showSwal.methods.showSwal({
                type: "success",
                message: resp.mensaje,
                width: 600,
            });
            this.fetchAndSetCanales();
            this.$emit('cerrar-modal');
        }
        else {
            showSwal.methods.showSwal({
                type: "error",
                message: resp.mensaje,
                width: 500
            });
        }
      }
      catch (error) {
        showSwal.methods.showSwal({
            type: "error",
            message: "Se ha producido un error",
            width: 500,
        });
      }
      finally {
        this.loadingBorrar = false;
        this.confirmacionVisible = false;
      }
    },
    editarCanal(id) {
      const row = this.filasBoton.find(r => r.id == id);
      if (!row) return;
      this.modalActive = true;
      this.tipoModal = 'E';
      this.canalEditNombre = row.nombre;
      this.canalEditEstado = row.estado;
      this.canalEditUuid = row.uuid;
      this.canalEditId = row.id;
    },
    copiarInitCanal(uuid) {
      navigator.clipboard.writeText(`/initCanal ${uuid}`).then(() => {
        showSwal.methods.showSwal({
          type: "success",
          message: 'Comando initCanal copiado al portapapeles',
          width: 600,
        });
      });
    },
    async verProductosCanal(canalId, canalNombre) {
      this.panelCanalNombre = canalNombre;
      this.panelProductos = [];
      this.panelProductosCargando = true;
      this.panelProductosVisible = true;
      try {
        const resp = await this.$store.dispatch('auth/productosDelCanal', canalId);
        this.panelProductos = resp?.data ?? [];
      } catch {
        this.panelProductos = [];
      } finally {
        this.panelProductosCargando = false;
      }
    },

    irInicio() {
      this.$router.push('/dashboard');
    }
  },

  async mounted() {
    this.$store.commit('setShowFooter', true);
    this.cargarColumnasStorage();
    if (this.miRol == 1) {
      const resp = await this.$store.dispatch("auth/listaTipsters");
      this.listaTipsters = Array.isArray(resp) ? resp : [];
    }
    this.initializeDataTable();
  },

};
</script>

<style scoped>
.borrados {
  display: flex;
  align-items: center;
  gap: 8px;
}
.borrados-label {
  font-size: 0.78rem;
  color: var(--q-muted);
  white-space: nowrap;
}
.filtro-tipster {
  display: flex;
  align-items: center;
  padding: 0 1rem;
}
.filtro-tipster select {
  min-width: 180px;
  font-size: 0.82rem;
}

/* Filtros canal */
.filtros-canal {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 0 1rem;
  flex-wrap: wrap;
}
.filtros-canal__grupo {
  display: flex;
  gap: 4px;
}
.filtro-pill {
  background: var(--q-card-alt);
  border: 1px solid var(--q-border-md);
  color: var(--q-muted);
  border-radius: 20px;
  padding: 4px 12px;
  font-size: 11px;
  font-weight: 600;
  cursor: pointer;
  transition: .15s;
  white-space: nowrap;
}
.filtro-pill:hover { border-color: var(--q-gold); color: var(--q-text); }
.filtro-pill--active { background: var(--q-gold); border-color: var(--q-gold); color: #1a1000; }

/* Canal badges */
.canal-badge {
  display: inline-block;
  padding: 2px 7px;
  border-radius: 20px;
  font-size: 10px;
  font-weight: 700;
  margin-left: 6px;
  vertical-align: middle;
  white-space: nowrap;
}
.canal-badge--free    { background: #d4edda; color: #155724; border: 1px solid #c3e6cb; }
.canal-badge--premium { background: #f8d7da; color: #721c24; border: 1px solid #f5c6cb; }

/* Panel productos */
.panel-productos {
  min-width: 520px;
  max-width: 90vw;
  padding: 0;
  overflow: hidden;
}
.panel-productos__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 20px 12px;
  border-bottom: 1px solid var(--q-border-md);
}
.panel-productos__header h6 { margin: 0; font-size: 0.9rem; }
.panel-productos__close {
  background: none;
  border: none;
  cursor: pointer;
  color: var(--q-muted);
  font-size: 1rem;
  padding: 0 4px;
}
.panel-productos__loading,
.panel-productos__empty {
  padding: 24px 20px;
  text-align: center;
  color: var(--q-muted);
  font-size: 0.85rem;
}
.panel-productos__tabla {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.82rem;
}
.panel-productos__tabla th {
  padding: 8px 16px;
  text-align: left;
  background: var(--q-card-alt);
  color: var(--q-muted);
  font-weight: 600;
  font-size: 0.75rem;
  text-transform: uppercase;
  letter-spacing: .04em;
}
.panel-productos__tabla td {
  padding: 10px 16px;
  border-top: 1px solid var(--q-border-md);
  vertical-align: middle;
}
.row-borrado td { opacity: .55; }
.badge-estado {
  display: inline-block;
  padding: 2px 8px;
  border-radius: 20px;
  font-size: 10px;
  font-weight: 700;
}
.badge-activo   { background: #d4edda; color: #155724; border: 1px solid #c3e6cb; }
.badge-inactivo { background: #fff3cd; color: #856404; border: 1px solid #ffeeba; }
.badge-borrado  { background: #f8d7da; color: #721c24; border: 1px solid #f5c6cb; }

/* Selector de columnas */
.descarga p.activo i { color: var(--q-gold, #ffd700); }

.descarga.triple {
  grid-template-columns: repeat(3, 1fr);
}

.selector-columnas-panel {
  position: absolute;
  top: calc(100% + 8px);
  right: 1rem;
  z-index: 999;
  background: var(--q-card, #1a1f2b);
  border: 1px solid var(--q-border, rgba(255,255,255,.1));
  border-radius: 12px;
  padding: 0;
  min-width: 280px;
  box-shadow: 0 12px 40px rgba(0,0,0,.4);
  overflow: hidden;
}
.selector-columnas-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.65rem 1rem;
  font-size: 0.8rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: .06em;
  color: var(--q-muted, #888);
  border-bottom: 1px solid var(--q-border, rgba(255,255,255,.08));
  background: var(--q-hover, rgba(255,255,255,.04));
}
.selector-reset {
  font-size: 0.72rem;
  color: var(--q-gold, #ffd700);
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  opacity: .75;
  transition: opacity .15s;
}
.selector-reset:hover { opacity: 1; }
.selector-columnas-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 2px;
  padding: 0.5rem;
}
.selector-col-item {
  display: flex;
  align-items: center;
  gap: 7px;
  padding: 6px 10px;
  border-radius: 8px;
  font-size: 0.8rem;
  cursor: pointer;
  transition: background .12s;
  user-select: none;
}
.selector-col-item:hover { background: var(--q-hover, rgba(255,255,255,.06)); }
.selector-col-item input[type="checkbox"] { margin: 0; cursor: pointer; accent-color: var(--q-gold, #ffd700); }
.selector-col-dot {
  width: 8px; height: 8px;
  border-radius: 50%;
  flex-shrink: 0;
}

/* ficha-buscador necesita position:relative para que el panel se posicione bien */
.ficha-buscador { position: relative; }
</style>



